import * as API from "@/store/actions/axios-api-instance";

export default async function makeRequest4BuyingLicense({commit}) {
    try {
        commit('SET_LOADING', true)
        await API.buyLicense()
        localStorage.setItem('request_has_been_sent', 'yes')
        commit('SET_REQUEST_TRUE')
        commit('SET_LOADING', false)
    } catch (e) {
        commit('SET_LOADING', false)
        commit('SET_ERROR', e.message)
        throw e
    }
}